/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { REPAIR_TIME_METHOD } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { REPAIR_TIME_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import { selectRunRepairTimeMethod } from '#selectors/entities/models.js';
import RepairTime from './RepairTime.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const { selectFormValues } = modelTypesByForm[form];

  const formRepairTimeMethod = selectFormValues(state, REPAIR_TIME_METHOD);
  const runRepairTimeMethod = selectRunRepairTimeMethod(state, ownProps);

  return {
    IsATC138: formRepairTimeMethod === REPAIR_TIME_METHOD_VALUES.ATC_138,
    showContent: formRepairTimeMethod === runRepairTimeMethod,
  };
};

export default connect(mapStateToProps)(RepairTime);
